const authProvider = {
    login: async ({ email, password }: { email: string; password: string }) => {
      const response = await fetch("/auth/api/token/", {
        method: "POST",
        body: JSON.stringify({ email, password }),
        headers: { "Content-Type": "application/json" },
      });

      const data = await response.json();

      if (!response.ok) {
        return Promise.reject(data);
      }

      if (!(data.user?.is_admin_user && data.user?.admin_role?.trim())) {
        return Promise.reject({ message: "Nicht autorisiert für den Adminbereich." });
      }

      localStorage.setItem("access_token", data.access);
      localStorage.setItem("refresh_token", data.refresh);
      return Promise.resolve();
    },
  
    logout: () => {
      localStorage.removeItem('access_token');
      return Promise.resolve();
    },
  
    checkAuth: () => {
      return localStorage.getItem('access_token') ? Promise.resolve() : Promise.reject();
    },
  
    checkError: (error: any) => {
      if (error.status === 401 || error.status === 403) {
        localStorage.removeItem('access_token');
        return Promise.reject();
      }
      return Promise.resolve();
    },
  
    getPermissions: () => {
      return Promise.resolve();
    },
  };
  
  export default authProvider;